import { render, staticRenderFns } from "./InsuranceCatalogue.vue?vue&type=template&id=3fd3cd40&scoped=true&"
import script from "./InsuranceCatalogue.vue?vue&type=script&lang=js&"
export * from "./InsuranceCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd3cd40",
  null
  
)

export default component.exports